<template>
    <div class="bind-tags">
      <div v-if="tagList&&tagList.length > 0">
        <a-tag
          style="margin-bottom: 4px; margin-top: 5px;"
          v-for="tag in tagList"
          :key="tag.id"
          @click="onClick"
        >
          {{ tag.tag_name }}
        </a-tag>
      </div>
      <div v-else>
        <a-tag key="new-tag" @click="onClick" style="margin-bottom: 4px; margin-top: 5px; background: #fff; borderStyle: dashed; animation-duration: 0s !important;">
        <a-icon type="plus"></a-icon> 新建
        </a-tag>
      </div>
      <a-modal
        title="添加标签"
        :visible="visible"
        :confirmLoading="confirmLoading"
        @ok="handleOk"
        @cancel="handleCancel"
        :closable="false"
        :centered="true"
        cancelText="取消"
        okText="完成"
        width="60%"
        style="height: 100px"
      >
        <a-list
          column="1"
          bordered
          split
          :data-source="categories"
          style="margin-bottom: 10px"
        >
          <a-list-item class="tag-list" slot="renderItem" slot-scope="item, index" :key="item.id">
            <span style="margin-bottom: 5px; margin-top: 5px; margin-right: 10px"> {{ item.category_name + '(' + item.total_count + ')' }}: </span>
            <a-checkable-tag
              style="margin-bottom: 4px; margin-top: 5px;"
              v-for="tag in item.tag_list"
              :key="tag.id"
              :checked="isChecked(tag)"
              @change="(checked) => handleChange(tag, checked)"
            >
              {{ tag.tag_name }}
            </a-checkable-tag>
          </a-list-item>
        </a-list>
      </a-modal>
    </div>
</template>

<script>
import AModal from 'ant-design-vue/es/modal/Modal'
import ACheckableTag from 'ant-design-vue/es/tag/CheckableTag'
const axios = require('axios')
export default {
  name: 'BindTags',
  components: {ACheckableTag, AModal},
  props: ['categories', 'tagList', 'dataIndex'],
  data () {
    // console.log('categories', this.tagList.length)
    return {
      batchBindTagsUrlPostfix: 'batch_bind_tags',
      confirmLoading: false,
      visible: false,
      selectedTags: [].concat(this.tagList)
    }
  },
  computed: {
    batchBindTagsUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.batchBindTagsUrlPostfix
    },
    tagIdList: function () {
      let tagIdList = []
      this.selectedTags.forEach((tag) => {
        tagIdList.push(tag.id)
      })
      return tagIdList
    }
  },
  methods: {
    onClick () {
      // console.log('onClick')
      this.visible = true
    },
    isChecked (tag) {
      // console.log('isChecked', tag)
      let checked = false
      const target = this.selectedTags.find(item => item.id === tag.id)
      if (target) {
        checked = true
      }
      return checked
    },
    handleOk () {
      // console.log('handleOk')
      this.confirmLoading = true
      axios.post(this.batchBindTagsUrl, {
        tag_id_list: this.tagIdList,
        chatroomname: this.dataIndex,
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            // console.log('重置免费一个群成功')
            // const dataSource = [...this.data]
            // const target = dataSource.find(item => item.client_id === clientId)
            // console.log('target', target)
            // if (target) {
            //   target['probation'] = 1
            //   console.log('dataSource', dataSource)
            //   this.data = dataSource
            // }

            this.$emit('on-tag-changed', this.dataIndex, this.selectedTags)
            this.visible = false
            this.confirmLoading = false
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    handleCancel () {
      // console.log('handleCancel')
      this.visible = false
      this.confirmLoading = false
      this.selectedTags = [].concat(this.tagList)
    },
    handleChange (tagChange, checked) {
      // console.log('handleChange')
      const selectedTagList = this.selectedTags
      if (checked) {
        if (this.selectedTags && this.selectedTags.length >= 5) {
          this.$message.error('一个群仅支持五个标签')
          return
        }
        let isDup = selectedTagList.some((selectedTag) => {
          return tagChange.id === selectedTag.id
        })
        if (!isDup) {
          this.selectedTags.push(tagChange)
        }
      } else {
        this.selectedTags = selectedTagList.filter(t => t.id !== tagChange.id)
      }
      console.log('handleChange', tagChange.id, this.tagList)
    }
  }
}
</script>

<style scoped>

</style>
